import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Box, Search, Text, Icon } from '@cubeyou-team/hx-react-components';

import { FoldersNavigation } from '../../components';
import {
  requestTargetFolders,
  requestTargetFolder,
  requestExploreTargetFolders,
  loadMoreRepository,
} from '../../actions/RepositoryActions';
import { getCurrentTargetTreeView } from '../../selectors/respository';

import {
  StyledFoldersSelector,
  StyledFoldersSelectorContainer,
  StyledFolderSelectorHeader,
  StyledFolderSelectorHeaderTitle,
} from './StyledFoldersSelector';

import translations from '../../lang';

class FolderSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      q: undefined,
      currentFolderId: 0,
    };
  }

  componentDidMount() {
    this.props.requestTargetFolders();
  }

  handleOnFolderRequest = (folder, path, loaded) => {
    this.props.onFolderSelect(folder, path, !!this.state.q);
    this.setState({
      ...this.setState,
      currentFolderId: folder.id,
    });

    if (!loaded) {
      return this.props.requestTargetFolder(folder.id);
    }

    if (folder.id === 0) {
      this.props.requestExploreTargetFolders(0);
    } else {
      this.props.requestExploreTargetFolders(folder.id);
    }
  };

  hanleOnSearchValue = q => {
    this.setState({
      ...this.state,
      currentFolderId: 0,
      q,
    });
    this.props.requestTargetFolders(q);
  };

  getTreeView = () => {
    if (this.props.selectedItem) {
      return this.props.currentTargetTreeView.filter(
        item => item.id !== this.props.selectedItem.id
      );
    }

    return this.props.currentTargetTreeView;
  };

  shouldCallLoadMore() {
    return true;
  }

  render() {
    const {
      isFolderSelectorLoading,
      shouldCallLoadMore,
      loadMoreRepository,
      targetQ,
    } = this.props;

    const { q, currentFolderId } = this.state;

    return (
      <StyledFoldersSelectorContainer>
        <Box mB="small">
          <Text size="small">
            {translations['en-US'].FOLDER_SELECTOR.TITLE}
          </Text>
        </Box>
        <Box pB="medium" borderPosition="bottom" borderSize="2px">
          <Box maxWidth="55%">
            <Search delay={500} onSearchChange={this.hanleOnSearchValue} />
          </Box>
        </Box>
        <StyledFoldersSelector>
          {currentFolderId === 0 && (
            <StyledFolderSelectorHeader>
              <StyledFolderSelectorHeaderTitle>
                <Box pR="medium">
                  <Icon icon="user" size="small" />
                </Box>
                <Text tag="span" size="small" weight="regular">
                  My Folders
                </Text>
              </StyledFolderSelectorHeaderTitle>
            </StyledFolderSelectorHeader>
          )}
          <FoldersNavigation
            isInitialLoading={isFolderSelectorLoading}
            isNextPageLoading
            shouldCallLoadMore={shouldCallLoadMore}
            treeView={this.getTreeView()}
            targetQ={targetQ}
            disableAudiences
            isSearching={q !== ''}
            onNavigationClick={this.handleOnFolderRequest}
            onLoadMoreRequest={() => loadMoreRepository('my')}
          />
        </StyledFoldersSelector>
      </StyledFoldersSelectorContainer>
    );
  }
}

const mapDispatchToProps = {
  requestTargetFolders,
  requestTargetFolder,
  requestExploreTargetFolders,
  loadMoreRepository,
};

const mapStateToProps = state => ({
  isFolderSelectorLoading: state.repository.isFolderSelectorLoading,
  targetQ: state.repository.targetQ,
  shouldCallLoadMore: state.repository.shouldCallLoadMore,
  currentTargetTreeView: getCurrentTargetTreeView(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(FolderSelector);
